import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function Impressum() {
  return (
    <>
      <Navbar />
      <main className="pt-24 md:pt-28 min-h-screen">
        <div className="max-w-3xl mx-auto px-4 md:px-6 py-16 md:py-24">
          <h1 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-2">
            Impressum
          </h1>
          <p className="text-sm text-foreground-500 mb-12">
            Angaben gemäß § 5 TMG
          </p>

          <div className="space-y-10 text-sm leading-relaxed text-foreground-700">
            {/* Anbieter */}
            <section>
              <h2 className="font-heading text-base font-semibold text-foreground-950 mb-3 pb-2 border-b border-background-200/70">
                Dienstanbieter
              </h2>
              <div className="space-y-1">
                <p className="font-medium text-foreground-800">Florale Manufaktur Blumen Stöhr GmbH</p>
                <p>Heisfelder Straße 105</p>
                <p>26789 Leer (Ostfriesland)</p>
                <p>Deutschland</p>
              </div>
            </section>

            {/* Vertretung */}
            <section>
              <h2 className="font-heading text-base font-semibold text-foreground-950 mb-3 pb-2 border-b border-background-200/70">
                Vertreten durch
              </h2>
              <p>Geschäftsführerin: Mareike Stöhr</p>
            </section>

            {/* Kontakt */}
            <section>
              <h2 className="font-heading text-base font-semibold text-foreground-950 mb-3 pb-2 border-b border-background-200/70">
                Kontakt
              </h2>
              <div className="space-y-1">
                <p>
                  <span className="text-foreground-500">Telefon:</span>{" "}
                  <a href="tel:04914238" className="hover:text-primary-600 transition-colors">0491 4238</a>
                </p>
                <p>
                  <span className="text-foreground-500">E-Mail:</span>{" "}
                  <a href="mailto:info@blumen-stoehr.de" className="hover:text-primary-600 transition-colors">info@blumen-stoehr.de</a>
                </p>
                <p>
                  <span className="text-foreground-500">Webseite:</span>{" "}
                  <a href="https://www.blumen-stoehr.de" className="hover:text-primary-600 transition-colors">www.blumen-stoehr.de</a>
                </p>
              </div>
            </section>

            {/* Handelsregister */}
            <section>
              <h2 className="font-heading text-base font-semibold text-foreground-950 mb-3 pb-2 border-b border-background-200/70">
                Registereintrag
              </h2>
              <div className="space-y-1">
                <p>Registergericht: Amtsgericht Aurich</p>
                <p>Handelsregisternummer: HRB 206099</p>
              </div>
            </section>

            {/* Streitschlichtung */}
            <section>
              <h2 className="font-heading text-base font-semibold text-foreground-950 mb-3 pb-2 border-b border-background-200/70">
                Streitschlichtung
              </h2>
              <p>
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
                <a
                  href="https://ec.europa.eu/consumers/odr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline hover:text-primary-600 transition-colors"
                >
                  https://ec.europa.eu/consumers/odr
                </a>
              </p>
              <p className="mt-2">
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </section>

            {/* Haftungshinweis */}
            <section>
              <h2 className="font-heading text-base font-semibold text-foreground-950 mb-3 pb-2 border-b border-background-200/70">
                Haftung für Inhalte
              </h2>
              <p>
                Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
              </p>
            </section>

            {/* Urheberrecht */}
            <section>
              <h2 className="font-heading text-base font-semibold text-foreground-950 mb-3 pb-2 border-b border-background-200/70">
                Urheberrecht
              </h2>
              <p>
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
              </p>
            </section>
          </div>

          <p className="text-xs text-foreground-400 mt-16 pt-6 border-t border-background-200/70">
            Stand: August 2026
          </p>
        </div>
      </main>
      <Footer />
    </>
  );
}